import React from "react";
import { apiPath } from "../utilities/Constants";
import useFetch from "../hooks/useFetch";
import GlobalForm from "../components/globalForm/GlobalForm";
import { updateData } from "../hooks/update";
import LoaderFilling from "../components/shared/Loader/LoaderFilling";

function SolutionsPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);

  // Loading screen
  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  // destructure necessary data
  const {
    solutionTitle,
    solutionSlogan,
    solutionDetails,
    solutionLink,
    solutionImg,
    _id,
  } = apiData[0] ?? {};

  // Form data
  const data = [
    {
      elementType: "textField",
      label: "solution Title",
      type: "Text",
      name: "solutionTitle",
      defaultValue: solutionTitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "solution Details",
      type: "Text",
      name: "solutionDetails",
      defaultValue: solutionDetails,
      required: false,
    },
    {
      elementType: "input",
      label: "solution Link",
      type: "Text",
      name: "solutionLink",
      defaultValue: solutionLink,
      required: false,
    },
    {
      elementType: "file",
      label: "solution Image",
      type: "file",
      name: "solutionImg",
      defaultValue: { url: solutionImg },
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "solution Slogan",
      type: "Text",
      name: "solutionSlogan",
      defaultValue: solutionSlogan,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(homeApi, data, _id);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default SolutionsPage;
